import React from 'react';
import {Row, Col} from "antd";
import {ArrowDownOutlined} from "@ant-design/icons";

function TraceTutorial () {

    return <>
        <div style={{marginLeft: 100}}>
            <Row>
                <Col flex="800px" style={{textAlign: 'left'}}>
                1、新建追踪参数：如果没有创建过渠道要先在“渠道管理”中新建渠道，然后在该渠道下新建参数
                </Col>
            </Row>
            <Row style={{margin: "10px 0 10px 0"}}>
                <Col flex="800px" style={{textAlign: 'center'}}>
                    <ArrowDownOutlined />
                </Col>
            </Row>
            <Row>
                <Col flex="800px" style={{textAlign: 'left'}}>
                    2、添加追踪参数：按约定的格式在售卖链接上添加追踪参数（每个项目组的格式可能不一样，具体请找对应的研发和运营确定），如：
                https://reading.baicizhan.com/h5/sales.html?buy_from=bhyd_xhs#/independent/harry-potter-book-set
                </Col>
            </Row>
            <Row style={{margin: "10px 0 10px 0"}}>
                <Col flex="800px" style={{textAlign: 'center'}}>
                    <ArrowDownOutlined />
                </Col>
            </Row>
            <Row>
                <Col flex="800px" style={{textAlign: 'left'}}>
                3、传递追踪参数：研发把参数传递至每一级页面，直到订单中的extra字段
                </Col>
            </Row>
            <Row style={{margin: "10px 0 10px 0"}}>
                <Col flex="800px" style={{textAlign: 'center'}}>
                    <ArrowDownOutlined />
                </Col>
            </Row>
            <Row>
                <Col flex="800px" style={{textAlign: 'left'}}>
                4、数据解析：数据中台从订单表的extra字段根据key解析参数信息，可以在解析后的订单表dwd_mall_trade_sub_stock_as_di的origin_referral_info字段查看订单来源
                </Col>
            </Row>
            <Row style={{margin: "10px 0 10px 0"}}>
                <Col flex="800px" style={{textAlign: 'center'}}>
                    <ArrowDownOutlined />
                </Col>
            </Row>
            <Row>
                <Col flex="800px" style={{textAlign: 'left'}}>
                5、看数：可以在数据中台看板
                https://datap.baicizhan.com/forms/fc_overview
                或
                https://datap.baicizhan.com/forms/abroad_core
                查看分渠道数据，或找商分查看详细数据～
                </Col>
            </Row>
        </div>
    </>
}

export default TraceTutorial
